<div class="is-relative">
    <isav-people-register-form (save)="onRegister($event)"> </isav-people-register-form>
    <isav-loader-overlay *ngIf="loading"></isav-loader-overlay>
</div>
